import {ValueOf} from 'next/constants'
import {memo, useCallback} from 'react'

import {BUTTON_BOX_SIZE, BUTTON_VARIANT, ButtonBox} from '@defign/ui'
import {Action, sendAULog} from '@financial/common-logs'
import classNames from 'classnames/bind'

import IconGraphHigh from '$assets/IconSvgs/insurance/IconGraphHigh'
import IconGraphLow from '$assets/IconSvgs/insurance/IconGraphLow'
import auBases from '$constants/auBases'
import {TAB_TYPE} from '$constants/insurance/diagnosis'
import {useUserInfoContext} from '$contexts/member/userInfoStatus'
import {useNewTabHooks} from '$hooks/insurance/useNewTabHooks'
import {sendClickNlog} from '$utils/nlog'

import styles from './InsuranceEstimate.module.scss'

const cx = classNames.bind(styles)

export const CheckCoverLayer = memo(function Layer({tabType}: {tabType: ValueOf<typeof TAB_TYPE>}) {
    const {targetProps, href} = useNewTabHooks()
    const {userInfo} = useUserInfoContext()

    const handleClickButton = useCallback(() => {
        sendClickNlog('insumy.diagnosischeckmycoverages')
        sendAULog(
            {
                ...auBases.insurance.homeB,
                code: userInfo.isLogin ? 'insu_check_coverages_unregistered' : 'insu_check_coverages_logoff',
            },
            Action.Click,
        )
    }, [userInfo.isLogin])

    return (
        <div className={cx('area-layer')}>
            <div className={cx('layer')}>
                <span className={cx('icon')}>
                    {tabType === TAB_TYPE.coverage ? (
                        <IconGraphLow width={30} height={30} />
                    ) : (
                        <IconGraphHigh width={30} height={30} />
                    )}
                </span>
                <strong className={cx('title')}>
                    또래에 비해 <b>{tabType === TAB_TYPE.coverage ? '부족한 보장' : '비싼 보험'}</b>이 있는지
                    <br />
                    점검해 보세요
                </strong>
                <div className={cx('button')}>
                    <ButtonBox
                        size={BUTTON_BOX_SIZE.LARGE}
                        variant={BUTTON_VARIANT.TERTIARY}
                        isWide
                        text={tabType === TAB_TYPE.coverage ? '내 보장 점검하기' : '내 보험료 점검하기'}
                        href={href}
                        onClick={handleClickButton}
                        {...targetProps}
                    />
                </div>
            </div>
        </div>
    )
})
